import { gql } from '@apollo/client'

export const TREND_SUMMED_DISCOUNT_DETAILS = gql`
  query TrendSummedDiscountDetails(
    $iFilter: JSON!
    $iEndDate: Date!
    $iGroupBy: String!
    $iDateRangeNumber: Int
  ) {
    trendSummedDiscountDetails(
      iFilter: $iFilter
      iEndDate: $iEndDate
      iGroupBy: $iGroupBy
      iDateRangeNumber: $iDateRangeNumber
    ) {
      nodes {
        startDate
        endDate
        totalCount
        totalAmount
        compsDetails
        totalGrossSales
      }
    }
  }
`
